var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 26L0.96967 25.4697L0.75 25.6893V26H1.5ZM25.875 1.625L26.4053 1.09467C26.1124 0.801777 25.6376 0.801777 25.3447 1.09467L25.875 1.625ZM33.375 9.125L33.9053 9.65533C34.1982 9.36244 34.1982 8.88756 33.9053 8.59467L33.375 9.125ZM9 33.5V34.25H9.31066L9.53033 34.0303L9 33.5ZM1.5 33.5H0.75C0.75 33.9142 1.08579 34.25 1.5 34.25L1.5 33.5ZM2.03033 26.5303L26.4053 2.15533L25.3447 1.09467L0.96967 25.4697L2.03033 26.5303ZM25.3447 2.15533L32.8447 9.65533L33.9053 8.59467L26.4053 1.09467L25.3447 2.15533ZM32.8447 8.59467L8.46967 32.9697L9.53033 34.0303L33.9053 9.65533L32.8447 8.59467ZM9 32.75H1.5V34.25H9V32.75ZM2.25 33.5V26H0.75V33.5H2.25ZM19.7197 7.78033L27.2197 15.2803L28.2803 14.2197L20.7803 6.71967L19.7197 7.78033Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.b5aa16d2.svg";
export { ForwardRef as ReactComponent };